export default {
    AsterLeadDelete: {
        getdata: []
    }
};